import { cx } from '@linaria/core';
import { Select } from '@ui/kit';
import { dropdownInput } from '@utils/component-framework';
import { usePageContext } from '../../../../context.js';
import { useOpgavekompleksetComponent } from '../../../../state/context.data.js';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { useInputState } from '../../hook.use-input-state.js';
import { StateBox } from '../atom.state-box/_state-box.js';
import { shouldHaveGroup, stateBox, dropdown, select } from './input.dropdown.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function DropdownInput(props) {
  const pageContext = usePageContext();
  const component = useOpgavekompleksetComponent();
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => dropdownInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = index => {
    update(props.taskEntryKey, props.node.id, {
      type: "dropdown",
      selectedIndex: inputEntry?.selectedIndex === index ? null : index
    });
  };
  const state = useInputState(props.node, inputEntry);
  if (state === "correct" || state === "incorrect") {
    const selectedOption = typeof inputEntry?.selectedIndex === "number" ? props.node.options[inputEntry?.selectedIndex] : undefined;
    return /*#__PURE__*/jsxs("span", {
      className: shouldHaveGroup,
      children: [/*#__PURE__*/jsx(StateBox, {
        state: state,
        textTheme: "colored",
        className: stateBox,
        children: selectedOption?.label || " "
      }), state === "incorrect" && /*#__PURE__*/jsx(StateBox, {
        state: "should-have",
        textTheme: "colored",
        className: stateBox,
        children: dropdownInput.getCorrectOption(props.node)?.label
      })]
    });
  }
  return /*#__PURE__*/jsx(Select, {
    className: cx(select, pageContext === "print" && "print", component.data.settings.standalone.audience),
    dropdownClassName: cx(dropdown, component.data.settings.standalone.audience),
    label: "",
    theme: "opgavekomplekset",
    dropdownPlacement: "bottom-end",
    collapseOnClick: true,
    disabled: state === "readonly",
    selectedValues: inputEntry?.selectedIndex != null ? [inputEntry.selectedIndex] : [],
    options: props.node.options,
    toggleValue: value => onChange(value)
  });
}

export { DropdownInput };
//# sourceMappingURL=input.dropdown.js.map
